import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseDeleteMutation, IDeleteFn, ITrainingPerson, IGetDeleteRequest } from '../../interfaces'

const getDeleteTrainingPersonMutationRequest: IGetDeleteRequest = params => {
  return {
    method: 'delete',
    url: `${config.baseUrl}/People/`,
  }
}

const useDeleteTrainingPersonMutation: IUseDeleteMutation<ITrainingPerson, number> = (params, options = {}) => {
  const request = useMemo(() => getDeleteTrainingPersonMutationRequest(params), [params])

  const deleteTraining: IDeleteFn<ITrainingPerson> = useCallback(
    async id => {
      return axios({ ...request, url: request.url + id }).then(res => res.data)
    },
    [request],
  )

  const response = useMutation<ITrainingPerson, Error, any>({ mutationFn: deleteTraining, ...options })

  return response
}

export default useDeleteTrainingPersonMutation
